import React from "react";
import {NoteView} from "./note.view";
import {INote} from "../../../../shared/interfaces/src";

export interface NoteProps  {
  note: INote
}

export const Note = (props: NoteProps) => {

  return (
    <NoteView key={props.note.id} {...props} />
  );
}
